module.exports = __webpack_public_path__ + "static/media/Fork_white.3f41c53c.svg";